import React from 'react';
import { Grid2 as Grid } from '@mui/material';
import { useIntl } from 'react-intl';
import { styled } from '@mui/material/styles';

import { FOOTER_HEIGHT, MOBILE_FOOTER_HEIGHT } from '../../Components/Footer/Footer';
import PeopleIllustration from './PeopleIllustration';
import CloudinaryImage from '../../Components/DesignSystem/CloudinaryImage';
import useSpace from '../../Hooks/useSpace';

const StyledContainer = styled(Grid)(({ theme: { breakpoints, mixins } }: any) => ({
  minHeight: `calc(100vh - ${mixins.toolbar['@media (min-width:600px)'].minHeight}px - ${FOOTER_HEIGHT}px)`,
  [breakpoints.down('md')]: {
    minHeight: `calc(100vh - ${mixins.toolbar.minHeight}px - ${MOBILE_FOOTER_HEIGHT}px)`,
  },
}));

const IllustrationWrapper = styled(Grid)(({ theme: { breakpoints, palette } }: any) => ({
  [breakpoints.down('md')]: {
    display: 'none',
  },
  backgroundColor: palette.background.default,
  position: 'fixed',
  height: '100%',
  right: 0,
}));

function AuthLayout({ children, alignSelf = 'center' }: any) {
  const intl = useIntl();
  const { space } = useSpace();

  return (
    <StyledContainer container>
      <Grid alignSelf={alignSelf} size={{ xs: 12, md: 6 }} sx={{ p: { xs: 2, lg: 8 } }}>
        {children}
      </Grid>

      <IllustrationWrapper size={{ md: 6 }}>
        {space.login_picture?.s3_key ? (
          <CloudinaryImage
            publicId={space.login_picture?.s3_key}
            width="100%"
            height="100%"
            style={{ objectFit: 'cover' }}
            alt={intl.formatMessage({ id: 'AUTH.BACKGROUND_ALT' })}
          />
        ) : (
          <PeopleIllustration title={intl.formatMessage({ id: 'AUTH.BACKGROUND_ALT' })} />
        )}
      </IllustrationWrapper>
    </StyledContainer>
  );
}

export default AuthLayout;
